<template>
  <div class="gj-table-parent_flex">
    <div style="display: flex;justify-content: space-between;line-height: 28px">
      <gj-area-title>费用分摊方式设置</gj-area-title>
       <gj-button type="text" @click="openLogs">操作日志</gj-button>
    </div>
    <div class="text-alert">
      <gj-text-alert type="info" font-size="12px" font-color="#666666">
        分摊方式调整后，于次日凌晨系统自动重算后对本月数据生效；如需对历史月份的数据生效，需在利润报表模块进行手动重算。
      </gj-text-alert>
    </div>

    <gj-table
        name="costAverage"
        adaptParent
        :index="true"
        :data="tableData"
        :columns="columns"
        :loading="loading">
      <template v-slot:content="{ row }">
        <gj-select
            :options="['advertisingSpend', 'monthlyStorageFee', 'longStorageFee'].includes(row.code) ? option.all : option.other"
            v-model="row.shareWay"
            :clearable="false"
            width="200px"
            @input="updateConfig($event, row)">
        </gj-select>
      </template>
    </gj-table>
  </div>
</template>

<script>
  import {queryMixin, responseMixin} from "@/minxins";
  import {feeShareWay, feeShareWayList} from "@/api/setting";
  import {isMeaningful} from "@/utils/common";
  import GjLogModal from "@/components/modal/gj-log-modal";

  export default {
    name: "app-finance-cost",
    mixins: [queryMixin, responseMixin],
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'name', header: '费用项', field: 'name', minWidth: '200px'},
          {id: 'content', header: '分摊方式', field: 'slot:content', minWidth: '200px'},
          {id: 'updateTime', header: '更新时间', field: 'updateTime', minWidth: '590px'},
        ],
        option:{
          all:[{id: 'salesMoneyRatio', text: '按销售额占比分摊'},
            {id: 'salesAmountRatio', text: '按销量占比分摊'},
            {id: 'difference', text: '差异分摊'},
            {id: 'businessReportRatio', text: '按业务报表占比分摊'},
            {id: 'businessReportValue', text: '从业务报表取值'},
            {id: 'customize', text: '自定义分摊'}],
          other:[
            {id: 'salesMoneyRatio', text: '按销售额占比分摊'},
            {id: 'salesAmountRatio', text: '按销量占比分摊'},
            {id: 'customize', text: '自定义分摊'}
          ]
        },
      }
    },
    methods: {
      openLogs(){
        this.$gjCreate(GjLogModal, {
          global: true,
          props: {
            url: '/finance/feeShareWayLog/page',
            columns: [
              {id: 'createDate', header: '操作时间', field: 'createTime', minWidth: '120px'},
              {id: 'updateUserName', header: '操作用户', field: 'updateUserName', minWidth: '100px'},
              {id: 'content', header: '操作内容', field: 'content', overflowLine: 2, minWidth: '350px'},
            ],
          }
        })
      },
      updateConfig(shareWay, row) {
        feeShareWay({
          id: row.id,
          code: row.code,
          shareWay: shareWay
        })
          .then((res) => {
            this.$gjResponseHandle(res, () => {
               this.$gjMessage.success('更新成功');
            });
          });
      },
      $gjQuery() {
        // 查询
        this.loading = true;
        let timeSign = setTimeout(() => {
          feeShareWayList().then((res) => {
            if (isMeaningful(res.data)) {
              this.tableData = res.data;
            } else {
              this.tableData = [];
            }
            clearTimeout(timeSign)
          }).complete(() => {
            this.loading = false;
            clearTimeout(timeSign)
          });
        }, 100);
      },
    }
  }
</script>

<style scoped lang="scss">
  /deep/ .gj-area-title {
    margin-bottom: 4px;
  }
  .text-alert{
    background: #EFF3FF;
    border: 1px solid #BBCDF9;
    border-radius: 4px;
    line-height:0;
    font-size: 12px;
    padding: 10px 5px;
    margin-top: 10px
  }
</style>

